module.exports = __webpack_public_path__ + "static/key-bioshock-9e822c568e448529ec714d2b9357c2ad.webp";